// src/components/checkout/DeliveryMethodSelector.jsx
import React from "react";
import useCheckoutStore from "../../store/useCheckoutStore";

const DeliveryMethodSelector = () => {
  const { checkoutData, updateCheckoutData } = useCheckoutStore();
  const { method } = checkoutData;

  return (
    <div className="card">
      <h2>Wybierz sposób dostawy</h2>
      <div className="method-selection-buttons">
        <button
          type="button"
          onClick={() => updateCheckoutData({ method: "delivery" })}
          className={method === "delivery" ? "selected-method" : ""}
        >
          Dostawa
        </button>
        <button
          type="button"
          onClick={() => updateCheckoutData({ method: "pickup" })}
          className={method === "pickup" ? "selected-method" : ""}
        >
          Odbiór osobisty
        </button>
      </div>
    </div>
  );
};

export default DeliveryMethodSelector;
